import { useSyncExternalStore } from "react";

import { readCacheHealth, subscribeCacheHealth, type CacheHealth } from "./cacheHealth";

/**
 * Its own file because `react-refresh/only-export-components` is an error for
 * `src/**`, and a hook exported beside non-component values breaks it.
 */
export function useCacheHealth(): CacheHealth {
  return useSyncExternalStore(subscribeCacheHealth, readCacheHealth, () => "ok" as const);
}
